import Translate from "./translate";
import * as THREE from "three";
import TWEEN from '@tweenjs/tween.js'
import { Mesh, Object3D } from "three";
import { TagType, MainSceneInfoPanel } from './enums';
import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';
import { faBolt, faWater, faWind, faHome, faCalendarAlt, faMale, faBurn, faBell, faThermometerHalf, faFan, faTint } from '@fortawesome/free-solid-svg-icons';

export function disposeResource(resource: any) {
  while (resource.children.length > 0) {
    let obj = resource.children[0];
    resource.remove(obj);
    disposeHierarchy(obj, disposeNode);

    obj = undefined;
  }

  if (resource.dispose) {
    resource.dispose();
  }

  resource = undefined;
}

function disposeHierarchy(node: any, callback: any) {
  for (var i = node.children.length - 1; i >= 0; i--) {
    var child = node.children[i];
    disposeHierarchy(child, callback);
    callback(child);
  }
  callback(node);
}

function disposeNode(node: any) {
  if (node instanceof Mesh) {
    if (node.parent)
      node.parent = null;

    if (node.geometry) {
      node.geometry.dispose();
    }

    if (node.material) {
      if (Array.isArray(node.material) || node.material instanceof THREE.MultiMaterial) {
        //@ts-ignore
        node.material.materials.forEach(function (mtrl, idx) {
          if (mtrl.map) mtrl.map.dispose();
          if (mtrl.lightMap) mtrl.lightMap.dispose();
          if (mtrl.bumpMap) mtrl.bumpMap.dispose();
          if (mtrl.normalMap) mtrl.normalMap.dispose();
          if (mtrl.specularMap) mtrl.specularMap.dispose();
          if (mtrl.envMap) mtrl.envMap.dispose();

          mtrl.dispose();    // disposes any programs associated with the material
        });
      }
      else {
        //@ts-ignore
        if (node.material.map) node.material.map.dispose();
        //@ts-ignore
        if (node.material.lightMap) node.material.lightMap.dispose();
        //@ts-ignore
        if (node.material.bumpMap) node.material.bumpMap.dispose();
        //@ts-ignore
        if (node.material.normalMap) node.material.normalMap.dispose();
        //@ts-ignore
        if (node.material.specularMap) node.material.specularMap.dispose();
        //@ts-ignore
        if (node.material.envMap) node.material.envMap.dispose();

        node.material.dispose();   // disposes any programs associated with the material
      }
    }
  }
  else if (node instanceof Object3D) {
    if (node.parent) {
      node.parent.remove(node);
      node.parent = null;
    }
  }

  if (node.dispose) {
    node.dispose();
  }
}

export function getErrorMessage(error: any) {
  if (error.response) {
    if (
      error.response.data &&
      error.response.data.Data &&
      error.response.data.Data.ErrorCode
    ) {
      return { message: Translate(`${error.response.data.Data.ErrorCode}`) };
    }

    if (
      error.response.data &&
      error.response.data.Data &&
      error.response.data.Data.Message
    ) {
      return { message: `${error.response.data.Data.Message}` };
    }

    if (error.response.data) {
      return { message: Translate(`${error.response.data}`) };
    }

    return { message: `${error.response.status} ${error.response.statusText}` };
  } else {
    return { message: Translate(`${error.message}`) };
  }
}

export function fomatDateTimeAsString(date: Date) {
  return (
    date.getFullYear().toString() +
    "/" +
    (date.getMonth() < 9
      ? "0" + (date.getMonth() + 1).toString()
      : (date.getMonth() + 1).toString()) +
    "/" +
    (date.getDate() < 10
      ? "0" + date.getDate().toString()
      : date.getDate().toString()) +
    " " +
    ("0" + date.getHours()).slice(-2) +
    ":" +
    ("0" + date.getMinutes()).slice(-2) +
    ":" +
    ("0" + date.getSeconds()).slice(-2)
  );
}

export function fomatDateTimeAsStringWithLang(date: Date, lang: string) {
  switch (lang) {
    case "bg":
      return (
        (date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString()) +
        "." +
        (date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString()) +
        "." +
        date.getFullYear().toString() +
        " г. " +
        ("0" + date.getHours()).slice(-2) +
        ":" +
        ("0" + date.getMinutes()).slice(-2)
      );

    case "en":
      return (
        (date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString()) +
        "/" +
        (date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString()) +
        "/" +
        date.getFullYear().toString() +
        " " +
        ("0" + date.getHours()).slice(-2) +
        ":" +
        ("0" + date.getMinutes()).slice(-2)
      );
  }
}

export function fomatDateTimeSecondsAsStringWithLang(date: Date, lang: string) {
  switch (lang) {
    case "bg":
      return (
        (date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString()) +
        "." +
        (date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString()) +
        "." +
        date.getFullYear().toString() +
        " " +
        ("0" + date.getHours()).slice(-2) +
        ":" +
        ("0" + date.getMinutes()).slice(-2) +
        ":" +
        ("0" + date.getSeconds()).slice(-2)
      );

    case "en":
      return (
        (date.getMonth() < 9
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString()) +
        "/" +
        (date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString()) +
        "/" +
        date.getFullYear().toString() +
        " " +
        ("0" + date.getHours()).slice(-2) +
        ":" +
        ("0" + date.getMinutes()).slice(-2) +
        ":" +
        ("0" + date.getSeconds()).slice(-2)
      );
  }
}
export function fomatTimeAsString(date: Date) {
  return (
    ("0" + date.getHours()).slice(-2) +
    ":" +
    ("0" + date.getMinutes()).slice(-2) +
    ":" +
    ("0" + date.getSeconds()).slice(-2)
  );
}

export function fomatTimeAsStringWithoutSeconds(date: Date) {
  return (
    ("0" + date.getHours()).slice(-2) +
    ":" +
    ("0" + date.getMinutes()).slice(-2)
  );
}

export function validateEmail(email: string) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function urlB64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function getURLParameter(name: string) {
  var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
    window.location.href
  );
  if (results == null) {
    return null;
  } else {
    return decodeURI(results[1]) || 0;
  }
}

export function formatDateToUTC(dateString: string) {
  var date = new Date(dateString);
  date.setHours(0, 0, 0);
  return date.toUTCString();
}

export function getEnumKeys(enumName: any) {
  return Object.keys(enumName).filter(k => typeof enumName[k as any] === "number");
}

export function getEnumLabel(
  id: number,
  enumName: any,
  withTranslation?: boolean
) {
  let enumElement = Object.keys(enumName).find(key => enumName[key] === id);

  if (withTranslation) {
    return Translate(enumElement);
  } else {
    return enumElement;
  }
}

export function getTagVisualisationType(dataVisualisationType: MainSceneInfoPanel) {
  switch (dataVisualisationType) {
    case MainSceneInfoPanel.TotalBuildingConsumption:
      return [TagType.Еlectricity, TagType.Water, TagType.Air, TagType.Gas];
    case MainSceneInfoPanel.EnergyDistribution:
      return [TagType.Compressor, TagType.Production, TagType.Lighting, TagType.Machines, TagType.Administration];
    case MainSceneInfoPanel.Common:
      return [TagType.DayWithoutAccidents, TagType.VisitorsMonth, TagType.VisitorsYear, TagType.Alarms];
    case MainSceneInfoPanel.WeatherStation:
      return [TagType.InternalTemperature, TagType.OutsideTemperature, TagType.WindSpeed, TagType.Humidity];
    default:
      return [0]
  }
}

export function getTagIcon(tagType?: number) {
  switch (tagType) {
    case TagType.Еlectricity:
      return faBolt;
    case TagType.Water:
      return faWater;
    case TagType.Air:
      return faWind;
    case TagType.Gas:
      return faBurn;
    case TagType.DayWithoutAccidents:
      return faCalendarAlt;
    case TagType.VisitorsMonth:
      return faMale;
    case TagType.VisitorsYear:
      return faMale;
    case TagType.Alarms:
      return faBell;
    case TagType.InternalTemperature:
      return faHome;
    case TagType.OutsideTemperature:
      return faThermometerHalf;
    case TagType.WindSpeed:
      return faFan;
    case TagType.Humidity:
      return faTint;
    default:
      return faTint
  }
}

export function getLegendColorByText(translated: string) {
  switch (translated) {
    case getEnumLabel(TagType.Production, TagType, true):
      return '#f47560';
    case getEnumLabel(TagType.Lighting, TagType, true):
      return '#d9cb55';
    case getEnumLabel(TagType.Machines, TagType, true):
      return '#e8a838';
    case getEnumLabel(TagType.Administration, TagType, true):
      return '#4a978a';
    case getEnumLabel(TagType.Compressor, TagType, true):
      return '#e8c1a0';
    default:
      return 'f47560';
  }
}

export function fadeMesh(mesh, direction, options?) {
  options = options || {};
  // set and check 
  var current = { percentage: direction === "out" ? 1 : 0 },
    // this check is used to work with normal and multi materials.
    mats = mesh.material.materials ?
      mesh.material.materials : [mesh.material],

    originals = mesh.userData.originalOpacities,
    easing = options.easing || TWEEN.Easing.Linear.None,
    duration = options.duration || 2000;
  // check to make sure originals exist
  if (!originals) {
    console.error("Fade error: originalOpacities not defined, use trackOriginalOpacities");
    return;
  }
  // tween opacity back to originals
  var tweenOpacity = new TWEEN.Tween(current)
    .to({ percentage: direction === "out" ? 0 : 1 }, duration)
    .easing(easing)
    .onUpdate(function () {
      for (var i = 0; i < mats.length; i++) {
        mats[i].opacity = originals[i] * current.percentage;
      }
    })
    .onComplete(function () {
      if (options.callback) {
        options.callback();
      }
    });
  tweenOpacity.start();
  return tweenOpacity;
}

export function trackOriginalOpacities(mesh) {
  let opacities: any[] = [];
  let materials = mesh.material.materials ? mesh.material.materials : [mesh.material];
  for (var i = 0; i < materials.length; i++) {
    materials[i].transparent = true;
    opacities.push(materials[i].opacity);
  }
  mesh.userData.originalOpacities = opacities;
}

export function dumpObject(obj: any, lines: any = [], isLast: boolean = true, prefix: string = '') {
  const localPrefix = isLast ? '└─' : '├─';
  lines.push(`${prefix}${prefix ? localPrefix : ''}${obj.name || '*no-name*'} [${obj.type}]`);
  const newPrefix = prefix + (isLast ? '  ' : '│ ');
  const lastNdx = obj.children.length - 1;

  obj.children.forEach((child: any, ndx: any) => {
    const isLast = ndx === lastNdx;
    dumpObject(child, lines, isLast, newPrefix);
  });
  return lines;
}

export function getMinMaxByTag(tagNum: number) {
  let min = 0;
  let max = 0;
  switch (tagNum) {
    case TagType.Еlectricity:
      min = 4300;
      max = 4900;
      break;
    case TagType.Water:
      min = 120;
      max = 360;
      break;
    case TagType.Air:
      min = 1200;
      max = 1600;
      break;
    case TagType.Gas:
      min = 2000;
      max = 2999;
      break;
    case TagType.DayWithoutAccidents:
      min = 5;
      max = 45;
      break;
    case TagType.VisitorsMonth:
      min = 40;
      max = 80;
      break;
    case TagType.VisitorsYear:
      min = 1400;
      max = 1700;
      break;
    case TagType.Alarms:
      min = 1;
      max = 10;
      break;
    case TagType.InternalTemperature:
      min = 18;
      max = 25;
      break;
    case TagType.OutsideTemperature:
      min = 0;
      max = 40;
      break;
    case TagType.WindSpeed:
      min = 0;
      max = 8;
      break;
    case TagType.Humidity:
      min = 30;
      max = 60;
      break;
    case TagType.Compressor:
      min = 10;
      max = 15;
      break;
    case TagType.Production:
      min = 30;
      max = 40;
      break;
    case TagType.Lighting:
      min = 5;
      max = 10;
      break;
    case TagType.Machines:
      min = 20;
      max = 35;
      break;
  }

  return { min, max }
}

export function addInteractivePoints(position, name, click, scene) {
  let greendot = document.createElement('div');
  greendot.setAttribute('class', 'green-dot-big fade-in');
  greendot.addEventListener('touchstart', click, false);
  greendot.addEventListener('click', click, false);
  let customGreenDot = new CSS2DObject(greendot);
  customGreenDot.position.set(position.x, position.y, position.z);
  customGreenDot.name = name;
  scene.add(customGreenDot);

  let dotEl = document.createElement('div');
  dotEl.setAttribute('class', 'custom-dot-main-hall fade-in');
  dotEl.addEventListener('click', click, false);
  dotEl.addEventListener('touchstart', click, false);
  let customDot = new CSS2DObject(dotEl);
  customDot.position.set(position.x, position.y, position.z);
  customDot.name = name + 'First';
  scene.add(customDot);

  let dotEl2 = document.createElement('div');
  dotEl2.setAttribute('class', 'custom-dot-two-main-hall fade-in');
  dotEl2.addEventListener('touchstart', click, false);
  let customDot2 = new CSS2DObject(dotEl2);
  customDot2.position.set(position.x, position.y, position.z);
  customDot2.name = name + 'Second';
  scene.add(customDot2);
}